import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';

export const ChangeGroupModalForm = ({ groupsOptions }) => {
	return (
		<Grid className="group-change-modal-form">
			<Grid.Row className="group-change-modal-form__row">
				<Grid.Column width={5} className="group-change-modal-form__column">
					Группа
				</Grid.Column>
				<Grid.Column width={8} className="group-change-modal-form__column">
					<Field
						name="group_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите группу"
						options={groupsOptions}
						noResultsMessage="Неизвестная группа"
						search
						isWithoutSelectOnBlur
						dropdownClassName="static"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

ChangeGroupModalForm.propTypes = {
	groupsOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
};
